import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import { IOrganizacao } from "../../../../Interfaces/Organizacao/Organizacao";

interface IOrganizacaoGeral {
    infoOrganizacao: IOrganizacao | undefined;
}

export default function InfoGeral(props: IOrganizacaoGeral) {
    const FormMethods = useForm();

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                usingContext
                handleSubmit={() => console.log("sem nada")}
                className="d-flex row justify-content"
            >
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_RAZAO_SOCIAL"
                        label="Razão Social"
                        readOnly
                        defaultValue={props.infoOrganizacao?.DS_RAZAO_SOCIAL}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_NOME_FANTASIA"
                        label="Nome Fantasia"
                        readOnly
                        defaultValue={props.infoOrganizacao?.DS_NOME_FANTASIA}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_EMAIL"
                        readOnly
                        label="Email"
                        defaultValue={props.infoOrganizacao?.DS_EMAIL}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="NR_TELEFONE"
                        label="Telefone"
                        readOnly
                        defaultValue={props.infoOrganizacao?.NR_TELEFONE}
                    />
                </div>                
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="ID_ORGANIZACAO"
                        label="ID Organização"
                        readOnly
                        defaultValue={props.infoOrganizacao?.ID_ORGANIZACAO}
                    />
                </div>
            </UnForm>
        </FormProvider>
    );
}
